module.exports = __webpack_public_path__ + "images/psp/SizeGuide/motorcycle/10x15.svg";